
const zIndex = {
    //dialog: 100,
    //header: 1100,
    loading: 999999,
    onfocus: 500
}

const transition = {
    all: 'all 0.35s cubic-bezier(0.15, 0.3, 0.25, 1) 0s',
    transform: 'transform 0.35s cubic-bezier(0.15, 0.3, 0.25, 1) 0s'
}


const MyTheme = {
    zIndex,
    transition
}
export default MyTheme;
